import React, { Component } from "react";
import stickyCtaImage from "../../../images/sticky-cta-left-img.png";
import IconStickyArrow from "../../../icons/icon-sticky-right-arrow.svg";
import ClosePopupImage from "../../../images/contact-close-x.svg";
import IconRightArrow from "../../../icons/arrow-right.svg"
import $ from "jquery";
import Select from 'react-select';
import { Link } from "gatsby";
import { submitForm } from '../templates/form/submitForm';
import IconCheckmarkImage from "../../../icons/icon-checkmark.svg";
import axios from "axios";
import countryList from 'react-select-country-list'
const emailValidation = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);


class StickyCtaBlock extends Component {

  constructor(props) {
    super(props);
    this.textInput = null;
    this.referrer = null;
    this.state = {
      name: "",
      nameValidation: "",
      email: "",
      emailValidation: "",
      contact: "",
      contactValidation: "",
      companyname: "",
      country: "",
      countryValidation: "success-field",
      inquirytype: "",
      inquirytypeValidation: "",
      requestmessage: "",
      requestmessageValidation: "",
      shouldSubmit: false,
      showSuccess: false,
      submitButtonState: "",
      isInView: false,
      isVisible: true,
      popupvisible: true,
      userCountryCode: '',
      userCountry: {"value" :'US',"label":'United States'},
      countryOptions: [],
    };
  }
  clearFields = () => {
    this.setState({
      name: "",
      nameValidation: "",
      email: "",
      emailValidation: "",
      contact: "",
      contactValidation: "",
      companyname: "",
      country: "",
      countryValidation: "",
      inquirytype: "",
      inquirytypeValidation: "",
      requestmessage: "",
      requestmessageValidation: "",
      shouldSubmit: false,
      showSuccess: false,
      submitButtonState: ""
    });
  };

  async componentDidMount() {
    this.referrer = document.referrer;

    $('.sticky-checkbox').prop('checked', true);

    const options = countryList().getData();

    const handleScroll = () => {
      let scrollY = window.scrollY;
      let windowHight = $(window).height() * 2;
      if (scrollY > windowHight && this.state.popupvisible) {
        $('.sticky-cta-section').addClass('show-sticky-cta');
      } else {
        //$('.sticky-cta-section').removeClass('show-sticky-cta');
      }
    };

    this.setState({ countryOptions : options })

    window.addEventListener('scroll', handleScroll, true);

  }

  componentWillUnmount() {

    const handleScroll = () => {
      let scrollY = window.scrollY;
      let windowHight = $(window).height() * 2;
      if (scrollY > windowHight) {
        $('.sticky-cta-section').addClass('show-sticky-cta');
      } else {
        //$('.sticky-cta-section').removeClass('show-sticky-cta');
      }
    };

    window.removeEventListener('scroll', handleScroll, true);
  }

  componentDidUpdate() {
    this.props.isVisible && this.nameRef.current.focus();
  }

  hidepopup = () => {
    $('.sticky-cta-contact-popup').fadeOut();
  }

  showpopup = () => {
    $('.sticky-cta-contact-popup').fadeIn().css("display", "flex");
  }

  checkFields = () => {
    const { nameValidation, emailValidation, contactValidation, countryValidation, inquirytypeValidation, requestmessageValidation } = this.state;
    if (nameValidation === 'success-field' &&
      emailValidation === 'success-field' &&
      contactValidation === 'success-field' &&
      //countryValidation === 'success-field' &&
      inquirytypeValidation === 'success-field' &&
      requestmessageValidation === 'success-field') {
      this.setState({
        shouldSubmit: true
      });
    }
    return {
      ...(!nameValidation) && { nameValidation: 'error-field', shouldSubmit: false },
      ...(!emailValidation) && { emailValidation: 'error-field', shouldSubmit: false },
      ...(!contactValidation) && { contactValidation: 'error-field', shouldSubmit: false },
      //...(!countryValidation) && { countryValidation: 'error-field', shouldSubmit: false },
      ...(!inquirytypeValidation) && { inquirytypeValidation: 'error-field', shouldSubmit: false },
      ...(!requestmessageValidation) && { requestmessageValidation: 'error-field', shouldSubmit: false },
    };
  };

  onSubmit = (event) => {

    event.preventDefault();
    if (this.state.submitButtonState === '') {
      this.setState(this.checkFields(),
        async () => {
          if (this.state.shouldSubmit) {
            this.setState({
              submitButtonState: "inProgress"
            });

            let formData = new FormData();
            formData.append("form_id", 13);
            formData.append("input_1", this.state.name);
            formData.append("input_2", this.state.email);
            formData.append("input_6", this.state.contact);
            formData.append("input_7", this.state.companyname);
            formData.append("input_8", this.state.country);
            formData.append("input_9", this.state.inquirytype);
            formData.append("input_10", this.state.requestmessage);
            formData.append("input_11", this.referrer);
            formData.append("input_12", this.props.pathname);


            const requestData = {
              method: 'post',
              url: 'https://rapidopsbackend.kinsta.cloud/wp-json/gf/v2/forms/13/submissions',
              data: formData
            };

            try {
              const response = await submitForm(requestData);
              if (response.status === 200 || response.status === 201) {
                $('.sticky-cta-section').removeClass('show-sticky-cta');
                setTimeout(() => {
                  this.setState({
                    submitButtonState: "finished",
                    isVisible: false,
                    popupvisible: false
                  });
                }, 1);
              }
              setTimeout(() => {
                this.clearFields();
                this.setState({
                  showSuccess: true
                })
              }, 1);
            }
            catch (error) {
              console.log(error);
            }
          }
        });
    }
  };

  handleSelect = (e) => {
    let obj = { "value":e.value , "label":e.label }
    this.setState({
      userCountry : obj,
      countryValidation : "success-field",
      country: e.label
    })
  }

  handleChange = (e) => {
    const name = e.target ? e.target.name : (e.name ? e.name : 'inquirytype') ;
    const value = e.target ? e.target.value : (e.value ? e.value : e) ;

    switch (name) {
      case 'name':
        if (!value)
          this.setState({
            nameValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            nameValidation: 'success-field',
          });
        break;


      case 'email':
        if (!emailValidation.test(value))
          this.setState({
            emailValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            emailValidation: 'success-field',
          });
        break;

      case 'contact':
        if (!value)
          this.setState({
            contactValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            contactValidation: 'success-field',
          });
        break;

      case 'requestmessage':
        if (!value)
          this.setState({
            requestmessageValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            requestmessageValidation: 'success-field',
          });
        break;

      case 'country':
        if (!value)
          this.setState({
            countryValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            countryValidation: 'success-field',
          });
        break;

      case 'inquirytype':
        if ( !value )
          this.setState({
            inquirytypeValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            inquirytypeValidation: 'success-field',
          });
        break;

      default:
        break;
    }
    const newState = {};
    newState[name] = value;
    this.setState(newState);
  };

  nameFocus = () => {
    this.textInput.focus();
  }

  inViewChange = (view) => {
    this.setState({
      isInView: view
    })
  }

  render() {
    const { nameValidation, emailValidation, contactValidation, countryValidation, inquirytypeValidation, requestmessageValidation, showSuccess, submitButtonState, isVisible } = this.state;

    const selectInquiryType = [
      {
        value: 'Rapidops Consulting', label: 'Rapidops Consulting'
      }, {
        value: 'Digital Services', label: 'Digital Services'
      }, {
        value: 'Digital Solutions', label: 'Digital Solutions'
      },{
        value: 'Others', label: 'Others'
      }
    ];

    return (
      <div>
        <div className="sticky-cta-section">
          <input className="sticky-checkbox" id="sticky-checkbox" type="checkbox" value="value1" />
          
          <div className="sticky-cta-inner">
            <label htmlFor="sticky-checkbox"><IconStickyArrow /></label>
            <div className="leftbar">
              <img src={stickyCtaImage} title="Get in Touch" alt="Get in Touch" />
            </div>
            <div className="rightbar">
              <h2>Get FREE Consultation on Smart Solutions</h2>
              <p>Talk with experts to reshape products, services & experiences</p>
              <a className="button button-small right-arrow show-contact-popup" onClick={this.showpopup}>Contact</a>
            </div>
          </div>
        </div>
        <div className="sticky-cta-contact-popup">
          <div className="container">
            <div className="form-section-contact-popup">
              {!showSuccess &&
                <div className="form-section-contact-popup-inner">
                  <div className="text-center contact-popup-heading section-gap">
                    <span className="form-title h1">TAKE THE NEXT STEP</span>
                    <p>Let’s talk about how new digital opportunities & smart solutions can work for your business.</p>
                  </div>
                  <form name="contact-popup" onSubmit={this.onSubmit} className="fomt-style-round">
                    <div className="form-row has-three-column">
                      <div className="form-column">
                        <input ref={(elem) => (this.textInput = elem)} placeholder="Name*" type="text" className={`form-input LoNotSensitive ${nameValidation}`} id="name" name="name" autoComplete="off" onChange={this.handleChange} value={this.state.name} tabIndex="1" />
                      </div>
                      <div className="form-column">
                        <input placeholder="Email*" type="email" name="email" className={`form-input LoNotSensitive ${emailValidation}`} id="email" autoComplete="off" onChange={this.handleChange} value={this.state.email} tabIndex="2" />
                      </div>
                      <div className="form-column">
                        <input ref={(elem) => (this.textInput = elem)} placeholder="Contact*" type="number" className={`form-input LoNotSensitive ${contactValidation}`} id="contact1" name="contact" autoComplete="off" onChange={this.handleChange} value={this.state.contact} tabIndex="3" />
                      </div>
                    </div>
                    <div className="form-row has-three-column">
                      <div className="form-column">
                        <input ref={this.nameRef} placeholder="Company" type="text" className={`form-input LoNotSensitive`} id="companyname" name="companyname" autoComplete="off" onChange={this.handleChange} value={this.state.companyname} tabIndex="4" />
                      </div>
                      <div className="form-column">
                        <Select id="country" name="country" className={`react-select LoNotSensitive ${countryValidation}`} options={this.state.countryOptions} isSearchable={false} placeholder='Country*' onChange={this.handleSelect} tabIndex="5" value={this.state.userCountry} />
                      </div>
                      <div className="form-column">
                        <Select id="inquirytype" name="inquirytype" className={`react-select LoNotSensitive ${inquirytypeValidation}`} options={selectInquiryType} isSearchable={false} placeholder='Inquiry Type*' onChange={this.handleChange} tabIndex="6" />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-column">
                        <textarea placeholder="Your Message*" rows="4" name="requestmessage" className={`form-input LoNotSensitive ${requestmessageValidation}`}
                          id="requestmessage" cols="20" autoComplete="off" onChange={this.handleChange} value={this.state.requestmessage} >
                        </textarea>
                      </div>
                    </div>
                    <div className="form-action">
                      <button type="submit" className={`button right-arrow  ${submitButtonState}`} tabIndex="6" >
                        <span className="submit">Submit</span>
                        <span className="loading"> Submit </span>
                        <span className="check"> <IconCheckmarkImage /> </span>
                      </button>
                      <p>By submitting this form you agree to our <Link to="/privacy-policy/">Privacy Policy</Link>.</p>
                    </div>
                  </form>
                </div>

              }
              {showSuccess &&
                <div className="thank-you-contact-popup text-center">
                  <span className="h1">Thank You for Contacting Us</span>
                  <p className="section-gap-small">Our team will contact you within two business days to schedule a call with our expert.</p>
                  <span className="h4">DISCOVER MORE &nbsp; <IconRightArrow /></span>
                  <p className="mb-40">Explore insights and foresight from our digital experts on the latest digital strategy and technology trends.</p>
                  <Link to="/blog/" className="button right-arrow">Our Insights</Link>
                </div>
              }
              <div className="close-contact-popup" onClick={this.hidepopup}>
                <img src={ClosePopupImage} title="Get in Touch" alt="Get in Touch" />
              </div>
            </ div>
          </div>
        </div>
      </div>
    );
  }
}

export default StickyCtaBlock;